import type { AccessRole } from '@gat-ship/types'
import { buildAccessRoleOptions } from '../model/access-role-options'

/**
 * View-model seam for the access-role picker. Components reach the option-building
 * functional core through this composable rather than importing `model/`
 * (the MVVM rule). Holds no reactive state of its own.
 */
export function useAccessRoleOptions() {
  function buildOptions(
    roles: readonly AccessRole[],
    preSelectedAccessRole?: AccessRole
  ) {
    return buildAccessRoleOptions(roles, preSelectedAccessRole)
  }

  return { buildOptions }
}
